import { getMFAPendingAppSetup, type MFASetupData } from '@/api/mfa';
import { useApiQuery } from '@/hooks/api';
import { queryKeys } from '@/shared/lib/queryKeys';

/**
 * Authenticator-app enrolment during login, authenticated by the short-lived
 * `mfaToken` rather than a session, so the result must never be cached across tokens.
 */
export function useMFAPendingAppSetup(mfaToken: string) {
  return useApiQuery<MFASetupData>({
    queryKey: queryKeys.mfa.pendingAppSetup(mfaToken),
    queryFn: () => getMFAPendingAppSetup(mfaToken),
    enabled: Boolean(mfaToken),
    retry: false,
    gcTime: 0,
  });
}
